export const ACTIVE_CALENDAR_SURFACE_VIEW: string = 'mini-active-calendar-view';
